import { User01 } from "@untitled-ui/icons-react";
import { useTranslation } from "react-i18next";

import ImageWithFallback from "@/components/media/ImageWithFallback";

type GroupProfileSectionProps = {
  name: string;
  imageThumb?: string | null;
  memberCount: number;
};

export default function GroupProfileSection({
  name,
  imageThumb,
  memberCount,
}: GroupProfileSectionProps) {
  const { t } = useTranslation("messenger.user");

  return (
    <div className="flex items-center gap-3 px-6 py-4">
      <div className="shrink-0 rounded-full">
        <ImageWithFallback
          src={imageThumb}
          alt={name}
          className="size-12 rounded-full object-cover"
          fallback={
            <div className="flex size-12 items-center justify-center rounded-full bg-gray-100">
              <User01 className="size-6 text-gray-600" />
            </div>
          }
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="truncate text-lg font-semibold text-gray-900">
          {name}
        </div>
        <div className="text-sm text-gray-600">
          {t("{{count}} members", { count: memberCount })}
        </div>
      </div>
    </div>
  );
}
